import React, { Component, PropTypes } from 'react';

class PagesCart extends Component {
    render() {
        return (
            <div>
                Content of PagesCart
                <hr />
                {this.props.children}
            </div>
        );
    }
}

PagesCart.propTypes = {
    children: PropTypes.element
};

export default PagesCart;



// WEBPACK FOOTER //
// ./src/components/pages/pages/PagesCart.js